module.exports = __webpack_public_path__ + "static/img/jxkp02.d045730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jxkp02.png
// module id = O7mm
// module chunks = 37